import { render, staticRenderFns } from "./BoardPosts.vue?vue&type=template&id=71465153"
import script from "./BoardPosts.vue?vue&type=script&lang=js"
export * from "./BoardPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports